"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var SocialTwitter = function (_a) {
    var fill = _a.fill, props = __rest(_a, ["fill"]);
    return (React.createElement("svg", __assign({ fill: "none", viewBox: "0 0 24 24", width: "1em", height: "1em" }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15 6c-1.719 0-3 1.291-3 2.75V11a1 1 0 0 1-.89.994c-1.526.17-4.764-.287-8.031-2.735a11.1 11.1 0 0 0 .38 2.087c.447 1.523 1.305 2.918 2.988 3.76a1 1 0 0 1 .309.24c.167.193.302.393.414.589a1 1 0 0 1-.434 1.4 31.78 31.78 0 0 1-1.834.806C6.518 18.71 8.22 19 9.935 19A8.065 8.065 0 0 0 18 10.993a1 1 0 0 1 .293-.7L19.586 9h-.666a1 1 0 0 1-.977-.788C17.679 6.992 16.498 6 15 6zM1.71 17.168l.003-.001.016-.005.065-.02.259-.084a35.152 35.152 0 0 0 2.345-.871c-1.56-1.157-2.405-2.733-2.858-4.28C1 10.063 1 8.195 1 7.034V7a1 1 0 0 1 1.707-.707C5.471 9.056 8.375 9.87 10 10.005V8.75C10 6.067 12.3 4 15 4c2.078 0 3.908 1.216 4.65 3H22a1 1 0 0 1 .707 1.707l-2.719 2.719C19.732 16.756 15.33 21 9.935 21c-2.06 0-4.105-.37-6.035-1.094l-2.25-.846a1 1 0 0 1 .06-1.893z", fill: fill || 'currentColor' })));
};
exports.default = SocialTwitter;
